module.exports = __webpack_public_path__ + "img/card_ip_stipulation42_2.7aa062ff.svg";